export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const PROFILE_USER = "PROFILE_USER";
export const ALL_PROFILE_USER = "ALL_PROFILE_USER";
export const SELLER_ACCOUNT = "SELLER_ACCOUNT";
export const COMPANY_NAME = "COMPANY_NAME";
export const BRAND = "BRAND";
export const COLOUR = "COLOUR";
export const UNIT = "UNIT";
export const BASIC_UNIT = "BASIC_UNIT";
export const PACKING_UNIT = "PACKING_UNIT";
export const PRODUCT_CODE = "PRODUCT_CODE";
export const CUSTOMER_ORDERBOOK_DATA = "CUSTOMER_ORDERBOOK_DATA";
export const VENDOR_NAME = "VENDOR_NAME";
export const FINISHGOODS_PRODUCT = "FINISHGOODS_PRODUCT";
export const RAWMATERIAL_PRODUCT = "RAWMATERIAL_PRODUCT";
export const CONSUMABLE_PRODUCT = "CONSUMABLE_PRODUCT";
